export type THeaderConfigIds =
    | "name-role"
    | "overall"
    | "effectiveness"
    | "risk"
    | "potential"
    | "situational"
    | "domain"
    | "functional"
    | "behavioural"
    | "organic_growth"
    | "sales_transformation"
    | "operational_effectiveness"
    | "tactical_m_a"
    | "digitisation"
    | "internationalisation"
    | "value_crystallisation"
    | "strategic_m_a";

export type THeaderConfigProps = {
    id: THeaderConfigIds;
    name: string;
    isHidable: boolean;
    sx: React.CSSProperties;
    isHidden?: boolean;
};

export const headerConfig: THeaderConfigProps[] = [
    {
        id: "name-role",
        name: "Name & Role",
        isHidable: false,
        sx: { width: 200 },
    },
    {
        id: "overall",
        name: "Overall",
        isHidable: true,
        sx: { width: 100, textAlign: "center" },
        isHidden: false,
    },
    {
        id: "effectiveness",
        name: "Effectiveness",
        isHidable: true,
        sx: { width: 100, textAlign: "center" },
        isHidden: false,
    },
    {
        id: "risk",
        name: "Risk",
        isHidable: true,
        sx: { width: 100, textAlign: "center" },
        isHidden: false,
    },
    {
        id: "potential",
        name: "Potential",
        isHidable: true,
        sx: { width: 100, textAlign: "center" },
        isHidden: false,
    },
    {
        id: "situational",
        name: "Situational",
        isHidable: true,
        sx: { width: 100, textAlign: "center" },
        isHidden: false,
    },
    {
        id: "domain",
        name: "Domain",
        isHidable: true,
        sx: { width: 100, textAlign: "center" },
        isHidden: false,
    },
    {
        id: "functional",
        name: "Functional",
        isHidable: true,
        sx: { width: 100, textAlign: "center" },
        isHidden: false,
    },
    {
        id: "behavioural",
        name: "Behavioural",
        isHidable: true,
        sx: { width: 100, textAlign: "center" },
        isHidden: false,
    },
    {
        id: "organic_growth",
        name: "Organic Growth",
        isHidable: true,
        sx: { width: 100, textAlign: "center" },
        isHidden: true,
    },
    {
        id: "sales_transformation",
        name: "Sales Transformation",
        isHidable: true,
        sx: { width: 100, textAlign: "center" },
        isHidden: true,
    },
    {
        id: "operational_effectiveness",
        name: "Operational Effectiveness",
        isHidable: true,
        sx: { width: 100, textAlign: "center" },
        isHidden: true,
    },
    {
        id: "tactical_m_a",
        name: "Tactical M&A",
        isHidable: true,
        sx: { width: 100, textAlign: "center" },
        isHidden: true,
    },
    {
        id: "digitisation",
        name: "Digitisation",
        isHidable: true,
        sx: { width: 100, textAlign: "center" },
        isHidden: true,
    },
    {
        id: "internationalisation",
        name: "Internationalisation",
        isHidable: true,
        sx: { width: 100, textAlign: "center" },
        isHidden: true,
    },
    {
        id: "value_crystallisation",
        name: "Value Crystallisation",
        isHidable: true,
        sx: { width: 100, textAlign: "center" },
        isHidden: true,
    },
    {
        id: "strategic_m_a",
        name: "Strategic M&A",
        isHidable: true,
        sx: { width: 100, textAlign: "center" },
        isHidden: true,
    },
];
